import type { SerializedEditorState } from "lexical";

export interface EmailDesignTemplateSettings {
  backgroundColour?: string;
}

export type SerialisedLexicalEditorDesign = SerializedEditorState & {
  type?: "lexical";
  template?: EmailDesignTemplateSettings;
};

export interface SerialisedMarkdownEditorDesign {
  type: "markdown";
  markdown: string;
  template?: EmailDesignTemplateSettings;
}

export type SerialisedEditorDesign = SerialisedLexicalEditorDesign | SerialisedMarkdownEditorDesign;

export const isMarkdownDesign = (
  design: SerialisedEditorDesign | undefined,
): design is SerialisedMarkdownEditorDesign =>
  design !== undefined && "type" in design && design?.type === "markdown";
